import { Breadcrumb } from 'antd';
import { createStyles } from 'antd-style';
import type { AppMenuItem } from '@/config/types';
import { useShellText } from '@/hooks/useShellText';
import { findMenuPath } from './sidebarNavigation';

const useStyles = createStyles(({ css }) => ({
  breadcrumb: css`
    min-width: 0;

    > ol {
      flex-wrap: nowrap;
    }
    .ant-breadcrumb-item {
      flex: 0 1 auto;
      min-width: 0;
    }
    .ant-breadcrumb-link {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .ant-breadcrumb-separator {
      flex-shrink: 0;
    }
  `,
}));

export function HeaderBreadcrumb({
  items,
  pathname,
  currentLabel,
  isPhone = false,
}: {
  items: AppMenuItem[];
  pathname: string;
  currentLabel?: string;
  isPhone?: boolean;
}) {
  const { styles } = useStyles();
  const t = useShellText();
  // 与菜单选中路径共用已过滤、本地化的菜单树，不从 URL 猜测层级。
  const trail = findMenuPath(items, pathname);
  const labels = trail.length
    ? trail.map((item) => item.name)
    : currentLabel
      ? [currentLabel]
      : [];

  if (!labels.length) return null;
  const visibleLabels = isPhone ? labels.slice(-1) : labels;

  return (
    <Breadcrumb
      aria-label={t('当前位置', 'Current location')}
      className={styles.breadcrumb}
      style={{ paddingInlineStart: isPhone ? 0 : 8 }}
      items={visibleLabels.map((label, index) => ({
        title: (
          <span
            title={label}
            aria-current={index === visibleLabels.length - 1 ? 'page' : undefined}
          >
            {label}
          </span>
        ),
      }))}
    />
  );
}
